import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { path, prop, identity, propOr, range } from "ramda";

// Actions
export const SET_NUMBER_OF_TITLE_PAGES =
  "DOMAIN@CONFIG::SET_NUMBER_OF_TITLE_PAGES";
export const SET_BOOK_TITLE = "DOMAIN@CONFIG::SET_TITLE";
export const SET_PAGES_COUNT = "DOMAIN@CONFIG::SET_PAGES_COUNT";

// Action Creators
export const setNumberOfTitlePages = createAction(SET_NUMBER_OF_TITLE_PAGES);
export const setTitle = createAction(SET_BOOK_TITLE);
export const setPagesCount = createAction(SET_PAGES_COUNT);

const getConfig = path(["domain", "config"]);

export const selectConfig = createSelector(getConfig, identity);

export const selectOffset = createSelector(getConfig, prop("offset"));

export const selectTitle = createSelector(getConfig, prop("title"));

export const selectPagesCount = createSelector(getConfig, prop("pagesCount"));

export const selectPagesRange = createSelector(selectPagesCount, count =>
  range(0, count)
);

export const selectCatsort = createSelector(getConfig, config => {
  const catsort = propOr({}, "catsort", config);
  const cleanSubCatTitles = titles =>
    titles.map(cat =>
      cat
        .split(">")
        .map(part => part.trim())
        .join(">")
    );
  return {
    book: cleanSubCatTitles(propOr([], "book", catsort)),
    pages: cleanSubCatTitles(propOr([], "pages", catsort))
  };
});

export const selectOutline = createSelector(getConfig, prop("outline"));

export const selectPrintablePages = createSelector(
  getConfig,
  prop("printablePages")
);

export const selectSize = createSelector(getConfig, prop("size"));

export const selectWidth = createSelector(selectSize, prop("width"));

export const selectHeight = createSelector(selectSize, prop("height"));

export const selectAspectRatio = createSelector(
  selectWidth,
  selectHeight,
  (width, height) => (height / width) * 100
);

export const selectFeatures = createSelector(getConfig, prop("features"));

export const selectIsDlsEnabled = createSelector(
  selectFeatures,
  propOr(false, "dls")
);

export const selectPageControl = createSelector(getConfig, prop("pageControl"));

export const selectUsersettingsConfig = createSelector(
  getConfig,
  prop("usersettings")
);

export const selectNonPrintableMessageUseDefault = createSelector(
  getConfig,
  prop("nonPrintableMessageUseDefault")
);

export const selectNonPrintableMessageAdditionalInfo = createSelector(
  getConfig,
  prop("nonPrintableMessageAdditionalInfo")
);

export const selectIsDrm = createSelector(getConfig, prop("drm"));

// Initial State
const initialState = () => ({
  offset: 0,
  title: "",
  pagesCount: 0,
  catsort: {
    pages: []
  },
  outline: [],
  drm: false,
  printablePages: [],
  size: {
    aspect: 0,
    width: 0,
    height: 0
  },
  features: {},
  pageControl: [],
  usersettings: []
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SET_NUMBER_OF_TITLE_PAGES:
      return { ...state, offset: action.payload };
    case SET_BOOK_TITLE:
      return { ...state, title: action.payload };
    case SET_PAGES_COUNT:
      return { ...state, pagesCount: action.payload };
    default:
      return state;
  }
}
